import { DocumentNumberRangeFieldV2 as DocumentNumberRange, DateRangeDropdownV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

const BasicInfo: React.FC = () => {
  return (
    <div className='space-y-2 p-4'>
      <div className='flex flex-col space-y-3'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Ngày từ/đến</Label>
          <div>
            <DateRangeDropdownV2 fromDateName='ngay_ct1' toDateName='ngay_ct2' />
          </div>
        </div>
        <div className='flex items-center'>
          <DocumentNumberRange fromName='so_ct1' toName='so_ct2' labelClassName='w-40 min-w-40' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
